import { Grid, IconButton, MuiThemeProvider } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { darkBlue, orangeThemeDark, originalOrange } from '../../core/theme';
import { WorksheetContext } from '../../core/visit-context';

interface AddItemLProps {
  onClick: (event?: any) => void;
  children?: any;
  buttonHeight?: string;
  context?: WorksheetContext;
}

export function AddItemLayout(props: AddItemLProps) {
  const buttonStyle = {
    width: '58px',
    backgroundColor: originalOrange,
    padding: '0px',
  };
  const expand = {
    width: '100%',
    padding: '0px 0px 0px 0px',
    overflowY: 'hidden',
  };

  return (
    <MuiThemeProvider theme={orangeThemeDark}>
      <Grid
        container
        direction="row"
        wrap="nowrap"
        spacing={2}
        style={{
          width: '100%',
          padding: '0px 0px 0px 0px',
          margin: '0px',
          overflow: 'hidden',
          backgroundColor: darkBlue,
        }}
      >
        {props.children.length ? (
          props.children.map((c, i) => (
            <Grid item key={i} style={expand as any}>
              {c}
            </Grid>
          ))
        ) : (
          <Grid item style={expand as any}>
            {props.children}
          </Grid>
        )}

        <Grid item container style={buttonStyle} alignItems="center">
          <IconButton
            id="add-element"
            disabled={props?.context?.readonly}
            onClick={(e) => props.onClick(e)}
          >
            <Add htmlColor="white" fontSize="large" />
          </IconButton>
        </Grid>
      </Grid>
    </MuiThemeProvider>
  );
}
